import { fetch } from 'cross-fetch';
import envConfig from '../config';
import { getCookie } from './cookie';

const defaultHeaders = {
  Accept: 'application/json',
  'Content-Type': 'application/json',
};

interface FetcherPostInterface {
  <Type>(body: Body): (url: string) => Promise<Type>;
}

type Body = { [K in keyof unknown]: K };

interface Resource {
  path: string;
  host?: string;
  method: 'GET' | 'POST';
  body: Body;
}

interface Fetcher {
  <T>(resource: Resource): Promise<T>;
}

export const fetcherPost: FetcherPostInterface = (body) => (path) => {
  return fetcher({
    method: 'POST',
    path,
    body,
  });
};

export const sleep = (ms: number) => {
  return new Promise((resolve) => setTimeout(resolve, ms));
};

export const fetcher: Fetcher = async (resource) => {
  const token = getCookie('session_token');
  const iduser = getCookie('user_id');

  const headers = {
    token,
    iduser,
  };

  const { host = envConfig.API_URL } = resource;

  const url = `${host}${resource.path}`;
  const r = await fetch(url, {
    headers: { ...headers, ...defaultHeaders } as HeadersInit,
    body: JSON.stringify(resource.body),
    method: resource.method,
  });

  // await sleep(2000);

  return r.json();
};

export const fetcherForMetrics = async (url: string, body: any) => {
  const r = await fetch(url, {
    headers: { ...defaultHeaders } as HeadersInit,
    body: JSON.stringify(body),
    method: 'POST',
  });

  return r.json();
};
